import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../services/admin/admin.service';
import { UiService } from '../../../../../../../services/ui/ui.service';
import { EventService } from '../../../../../../../services/event/event.service';
import swal from 'sweetalert2';
import { HelperService } from '../../../../../../../services/helper/helper.service';

@Component({
  selector: 'app-view-exam-modal',
  templateUrl: './view-exam-modal.component.html',
  styleUrls: ['./view-exam-modal.component.css']
})
export class ViewExamModalComponent implements OnInit {

  public exam = null;

  constructor(
    private adminService: AdminService,
    private ui: UiService,
    private event: EventService,
    public helper: HelperService
  ) { }

  ngOnInit() {
    this.event.on('view-exam-modal', 'viewExamModal', ({ examId }) => {
      this.exam = null;
      this.getExamDetails(examId);
    });
  }

  getExamDetails(examId) {
    this.ui.loader.show('view-exam-modal => getExamDetails');
    this.adminService.getExam(examId, (err, res) => {
      this.ui.loader.hide('view-exam-modal => getExamDetails');
      if (err) {
        if (Object.keys(err).length) {
          swal('Error', err[Object.keys(err)[0]], 'error');
        }
      } else {
        this.exam = res;
        this.exam.file = this.exam.file || [];
      }
    });
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/programme/programme-details/modals/view-exam-modal/view-exam-modal.component.ts